import {
    Component,
    HostBinding,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "rask-label",
    templateUrl: "./label.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./label.component.scss"]
})
export class LabelComponent implements OnInit {

    @HostBinding("class") labelClass: string;
    @Input() size = "1";
    @Input() noCol = false;

    ngOnInit(): void {
        this.initSize();
    }

    initSize() {
        if (this.noCol) {
            return;
        }
        this.labelClass = `col-lg-${this.size}`;
    }

}
